// extracted by mini-css-extract-plugin
export default {"root":"VMdeDwa5GkpFNdVuYEub","content":"UkwAZrgb9qt4uvQx3I4R","icon":"hru8sfzzwH7px0zamAWQ","balance":"euurABQRuOainXjnzAny","placeHolderShimmer":"vhoHtvmG0XBf0lqRjIzQ"};